import React from "react";
import { Modal } from "react-bootstrap";
import InputText from "../../common/Input/InputText";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";

const Addrolemodal = ({
  showModal,
  setModalVisible,
  modalAction,
  formData,
  handleAddOrUpdateRole,
  handleChange,
  setInputError
}) => {
  return (
    <div>
      <Modal
        centered
        show={showModal}
        onHide={() => setModalVisible(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {modalAction === "create" ? "Add Role" : "Update Role"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleAddOrUpdateRole}>
            <div className="row">
              <div className="col-xl-12">
              <InputText
                 placeholder="Name"
                 name="name"
                 value={formData.name}
                 onChange={handleChange}
                 label="Name"
                 required={true}
                 fieldName="This field"
                 setInputTextError={setInputError}
                />
              </div>
              <div className="col-xl-12">
              <InputOnlyNumber
                 name="customRoleId"
                 value={formData.customRoleId}
                 onChange={handleChange}
                  placeholder="roleId"
                  label="roleId"
                  required={true}
                  fieldName="roleId"
                  setInputOnlyNumberError={setInputError}
                />
              </div>
              <div className="col-xl-12">
                <div className="form-group">
                  <label htmlFor="description" className="col-form-label">
                    Description:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                    placeholder="Description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-xl-12">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="status" className="col-form-label me-3">
                    Status:
                  </label>
                  {["Active", "Inactive", "Deleted"]?.map((status) => (
                    <div className="form-check me-3" key={status}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        id={status.toLowerCase()}
                        value={status}
                        checked={formData.status === status}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={status.toLowerCase()}
                      >
                        {status}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success">
                {modalAction === "create" ? "Add Role" : "Update Role"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default Addrolemodal;